export const createBufferedLayer = {
  LAYER_BUFFER_STARTED: 'LAYER_BUFFER_STARTED',
  LAYER_BUFFER_DONE: 'LAYER_BUFFER_DONE',
  LAYER_BUFFER_ERROR: 'LAYER_BUFFER_ERROR',
} as const;
